// Interactive map for the Incident Drawer Map Panel. Pure react-map-gl with
// no Chakra, so like StaticMapBox it lives in the web-app dark tree rather
// than @hivewatch/dark — map dependencies don't belong in the design system.
import { useEffect, useRef } from 'react'

import { Map, Marker } from 'react-map-gl'
import type { MapRef } from 'react-map-gl'

import { FacilityMapMarker } from '@hivewatch/dark'

const INITIAL_ZOOM = 17

interface MapPanelBodyIProps {
  hasActiveIncident: boolean
  latitude: number
  longitude: number
  shortName: string
}

export const MapPanelBody = ({
  hasActiveIncident,
  latitude,
  longitude,
  shortName,
}: MapPanelBodyIProps) => {
  const mapRef = useRef<MapRef>(null)

  // Mapbox GL doesn't reliably auto-resize its canvas when the container
  // dimensions change from non-window sources; this map mounts inside an
  // absolutely positioned panel mid slide-out animation, so resize() ensures
  // the canvas matches the settled panel size.
  useEffect(() => {
    mapRef.current?.resize()
  }, [])

  return (
    <Map
      initialViewState={{ latitude, longitude, zoom: INITIAL_ZOOM }}
      mapStyle='mapbox://styles/mapbox/satellite-streets-v12'
      mapboxAccessToken={process.env.NEXT_PUBLIC_MAPBOX_API_TOKEN}
      ref={mapRef}
      style={{ height: '100%', width: '100%' }}
    >
      {/* The same marker the Global Map shows for this facility, so one
          facility reads the same on both surfaces. The count only selects the
          alert coloring here — with the badges off the number is never drawn,
          and the drawer has no facility-wide count to pass. ENG-33675 */}
      <Marker anchor='center' latitude={latitude} longitude={longitude}>
        <FacilityMapMarker
          incidentCount={hasActiveIncident ? 1 : 0}
          shortName={shortName}
          showIncidentBadges={false}
        />
      </Marker>
    </Map>
  )
}
